

import React, { useState, useMemo } from 'react';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import taskServices from '../../tasks/taskServices';
import moment from 'moment';
import { useAppData } from '../../../../../context/AppDataContext';
import TaskProgressGauge from './editor/TaskProgressGuage';
import TaskDetailsView from './TaskDetailsView';
import AssigneeBadge from './editor/AssigneeBadge';
import TaskStatusBadge from './editor/TaskStatusBadge';
import PriorityBadge from './editor/PriorityBadge';
import TaskForm from './TaskForm';
import { Link } from 'react-router-dom';
import TaskScheduleBadge from './editor/TaskScheduleBadge';

import 'react-big-calendar/lib/css/react-big-calendar.css';

const localizer = momentLocalizer(moment);


const CustomEvent = ({ event }) => (
  <div style={{ 
    display: 'flex', 
    alignItems: 'center', 
    gap: '4px', 
    fontSize: '11px',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
  }}>
    <span>{taskServices.priorityDots[event.priority]}</span>
    <span>{taskServices.typeIcons[event.calendarType] || '📍'}</span>
    <strong>{moment(event.start).format('h:mm A')}</strong>
    <span style={{ marginLeft: '4px' }}>{event.title}</span>
  </div>
);


function TaskCalendarView({taskList, callBack}) {    
    const [taskDetails,setTaskDetails] = useState(null);
    const {projectDD,getDDDataById} = useAppData();
    const handleCallBack = () =>{
        setTaskDetails(false);
        callBack();
    }


    const formattedEvents = useMemo(() => {
        if (!taskList) return [];
        return taskList.map(task => ({
            ...task,
            start: new Date(`${task.startDate}T${task.startTime}`),
            end: new Date(`${task.endDate}T${task.endTime}`),
        }));
    }, [taskList]);


    return (
        <div className='row'>
            <div className='col-md-12'>
                <div style={{ height: '75vh', padding: '20px' }}>
                    {taskList && 
                        <Calendar
                            localizer={localizer}
                            events={formattedEvents}
                            startAccessor="start"
                            endAccessor="end"
                            style={{ height: '100%' }}
                            onSelectEvent={(event)=>setTaskDetails(event)}
                            // 2. Map the custom component
                            
                            components={{
                                event: CustomEvent
                            }}
                            
                            //eventPropGetter={eventStyleGetter}

                            selectable={true} 
                            //onSelectSlot={handleSelectSlot}
                            longPressThreshold={10} // Makes it more responsive on mobile
                        />
                    }
                </div>
                <TaskDetailsView taskDetails={taskDetails} setTaskDetails={setTaskDetails} callBack={handleCallBack} />
            </div>
        </div>
  )
}

export default TaskCalendarView